module.exports = __webpack_public_path__ + "img/carousel3.be8f9390.png";